import { cn } from "tools/ui";

const base = "w-1.5 h-1.5 mx-auto rounded-full";

function NoInfo({ color }) {
  return (
    <div className="mx-auto border-2 rounded-lg border-dashed border-neutral-300 p-10 text-neutral-400 font-bold">
      No information available
    </div>
  );
}

export default NoInfo;
